export default "__VITE_ASSET__c91d51ae__"